import FormForgotPassword from 'components/FormForgotPassword';
import FormForgotPasswordMobile from 'components/FormForgotPassword/mobile';
import Introduction from 'components/FormLogIn/components/Introduction';
import { DESKTOP_MIN_WIDTH } from 'constants';
import { useDetectDevice } from 'hooks/useDetectDevice';
import styled from 'styled-components';

const ForgotPasswordPage = () => {
  const { isMobile, isTablet } = useDetectDevice();

  if (isMobile || isTablet) {
    return (
      <ForgotPasswordStyled>
        <FormForgotPasswordMobile />
      </ForgotPasswordStyled>
    );
  }
  return (
    <ForgotPasswordStyled>
      <Introduction />
      <FormWrap>
        <FormForgotPassword />
      </FormWrap>
    </ForgotPasswordStyled>
  );
};

const ForgotPasswordStyled = styled.div`
  padding: 24px;
  padding-top: 94px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    padding: 0;
    display: grid;
    grid-template-columns: 55% 45%;
    align-items: end;
    margin-block: auto;
  }

  @media screen and (min-width: 1440px) {
    grid-template-columns: 60% 40%;
    margin-block: 112px auto;
  }

  @media screen and (min-width: 2560px) {
    margin-block: 148px auto;
  }
`;

const FormWrap = styled.div`
  background: transparent;

  @media screen and (min-width: 1280px) {
    width: 485px;
    height: 530px;
  }

  @media screen and (min-width: 1440px) {
    width: 517px;
    height: 638px;
  }
`;

export default ForgotPasswordPage;
